inits.push("ImportFB.init()");


window.ImportFB = {
    init: function() {
        if ($('#ImportFB-toggle').length) {
            function ImportFBChange(event, state) {
                $("[name='HWP-ImportFB']").val((state ? 'on' : 'off'));
                var postData = {
                    ImportFB: state
                };
                $.ajax({
                    type: "POST",
                    url: '/Handler/HvD/ImportFB',
                    data: postData
                }).done(function(data) {
                    // console.debug(data);
                    // toast gespeichert
                    tools.toast('Import', 'Import-Fallback gespeichert');
                });
            }

            $("[name='HWP-ImportFB']").bootstrapSwitch({
                onText: 'An',
                offText: 'Aus',
                // onInit: getState,
                onSwitchChange: ImportFBChange
            });
        }
        if ($('#Banner-toggle').length) {
            if (!document.getElementById('Banner-toggle').checked) {
                document.getElementById('bannerContainer').classList.add('hidden');
            }

            function BannerChange(event, state) {
                $("[name='HWP-Banner']").val((state ? 'on' : 'off'));

                var postData = {
                    banner: state,
                    isPublic: $("[name='HWP-Banner-Public']").val(),
                    bannerText: document.getElementById('bannerText').innerHTML
                };

                if (state) {
                    document.getElementById('bannerContainer').classList.remove('hidden');
                } else {
                    document.getElementById('bannerContainer').classList.add('hidden');
                }
                $.ajax({
                    type: "POST",
                    url: '/Handler/HvD/Banner',
                    data: postData
                }).done(function(data) {
                    tools.toast('Banner', 'Banner gespeichert');
                });
            }
            document.getElementById('bannerTextSave').addEventListener('click', function() {
                BannerChange(null, document.getElementById('Banner-toggle').checked);
            });

            $("[name='HWP-Banner']").bootstrapSwitch({
                onText: 'An',
                offText: 'Aus',
                // onInit: getState,
                onSwitchChange: function(ev, state) {
                    if (state) {
                        document.getElementById('bannerContainer').classList.remove('hidden');
                    } else {
                        document.getElementById('bannerContainer').classList.add('hidden');
                    }
                }
            });
            $("[name='HWP-Banner-Public']").bootstrapSwitch({
                onText: 'Public',
                offText: 'Admin',
                // onInit: getState,
                onSwitchChange: function(ev, state) {
                    this.value = state;
                }
            });
        }
    }
};
